import { cn, Skeleton } from '@/core/ui';

export function BlogItemSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'flex flex-col group relative',
        'shrink-0',
        'bg-content1',
        'rounded-lg',
        'border border-default-200',
        'hover:border-default-300',
        'transition-all duration-300',
        'shadow-sm backdrop-blur-xl',
        className,
      )}
    >
      <div className='p-3.5 flex flex-row gap-3'>
        <Skeleton className='shrink-0 w-28 h-24 rounded-md' />
        <div className='flex-1 min-w-0 flex flex-col gap-1.5'>
          <div className='flex items-start justify-between gap-2'>
            <div className='flex flex-col items-start gap-1 w-full min-w-0'>
              <div className='flex items-center gap-1'>
                <Skeleton className='size-4 rounded-md' />
                <Skeleton className='h-4 w-28 rounded' />
              </div>
              <Skeleton className='h-2.5 w-5/6 max-w-xs rounded' />
            </div>
          </div>
          <div className='mt-0.5'>
            <Skeleton className='w-full h-0.5 rounded max-w-md' />
          </div>
          <div className='space-y-1'>
            <Skeleton className='h-3 w-full rounded' />
            <Skeleton className='h-3 w-4/5 rounded' />
          </div>
          <div className='flex items-center gap-1 flex-wrap mt-auto pt-0.5'>
            <Skeleton className='h-5 w-14 rounded-lg' />
            <Skeleton className='h-5 w-16 rounded-lg' />
            <Skeleton className='h-5 w-12 rounded-lg' />
            <div className='flex-1 flex justify-end'>
              <Skeleton className='h-3 w-20 rounded' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
